<template>
    <div class="dataloggerManage">
        <div class="section">
            <div class="buttons">
                <el-button type="primary" class="btn btn-dark buttonType"
                    @click="openDiaolog('adminRebuildDeviceRealTimeDat')">{{ $t('device.device_rerolling') }}</el-button>
                <el-button type="primary" class="btn btn-dark buttonType"
                    @click="openDiaolog('adminRebuildDisDeviceRealTimeDat')">{{ $t('device.device_synchronization') }}</el-button>
                <el-button type="primary" class="btn btn-dark buttonType" @click="openDiaolog(null)">{{ $t('device.update_first_data_time') }}</el-button>
                <el-button type="primary" class="btn btn-dark buttonType"
                    @click="openDiaolog('adminDeleteEssDeviceRealtimeData')">{{ $t('device.delete_device_chart_data') }}</el-button>
                <el-button type="primary" class="btn btn-dark buttonType"
                    @click="openDiaolog('adminWebDeleteDeviceDat')">{{ $t('device.delete_device_data') }}</el-button>
            </div>
            <div class="search">
                <div class="searchLeft">
                    <el-form ref="searchForm" :model="searchForm" class="searchForm" :rules="searchFormRules"
                        :show-message="false">
                        <el-form-item label="PN" prop="pn">
                            <el-input v-model.trim="searchForm.pn" placeholder="PN"></el-input>
                        </el-form-item>
                        <el-form-item label="SN" prop="sn" >
                            <el-input v-model.trim="searchForm.sn" placeholder="SN"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('device.device_code1')" prop="devcode" >
                            <el-input v-model.trim="searchForm.devcode" :placeholder="$t('device.device_code1')"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('device.device_address')" prop="devaddr">
                            <el-input v-model.trim="searchForm.devaddr" :placeholder="$t('device.device_address')"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('actionLog.date')" prop="date">
                            <el-date-picker v-model="searchForm.date" type="date" :editable="false" :clearable="false" :picker-options="pickerrangeOptions"
                                value-format="yyyy-MM-dd" :placeholder="$t('device.pleaseDate')" popper-class="select-date"></el-date-picker>
                        </el-form-item>
                        <el-button class="button button-solid" @click.stop="getData">
                            <i class="el-icon-search"></i>
                        </el-button>
                    </el-form>
                </div>

            </div>
            <!-- 表格 -->
            <div class="dataTable tablemain">
                <table border="1" cellspacing="0">
                    <thead>
                        <tr>
                            <th v-for="(item, index) in rowTitle" :key="index">
                                <span v-if="item.unit">{{ item.title + '(' + item.unit + ')' }}</span>
                                <span v-else>
                                    {{ item.title }}
                                </span>
                            </th>
                            <th v-if="dataList.length > 0">{{ $t('settingalarm.Operation') }}</th>
                        </tr>
                    </thead>
                    <tr v-for="(item, index) in dataList" :key="index">
                        <td v-for="(itemSon, index) in item.field" :key="index">{{ itemSon }}</td>
                        <td>
                            <el-button type="text" class="operation" :title="$t('device.delete')" @click="cellDelete(item)">
                                <i class="iconfont icon-caozuo_shanchu"></i>
                            </el-button>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="tablebottom" v-if="dataList.length > 0">
                <el-pagination class="pagination" background @current-change="() => getData()"
                    :current-page.sync="pagination.page" :page-size.sync="pagination.pagesize"
                    layout="slot, total, pager, prev, next, jumper" :total="pagination.total"
                    popper-class="select-page">

                </el-pagination>
            </div>
            <!-- 五合一弹框 -->
            <account-dialog :title="dialogTitle" :visible.sync="showDialog" width="550px"
                :class="{ 'showDialog': showDialog, 'hideDialog': !showDialog }" noFooter>
                <el-form ref="creatForm" :model="dialogForm" class="chuangjian grid" slot="content"
                    :rules="dialogRules">
                    <el-form-item :label="$t('device.PN')" prop="pn">
                        <el-input v-model.trim="dialogForm.pn" clearable placeholder="PN"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('device.SN')" prop="sn">
                        <el-input v-model.trim="dialogForm.sn" clearable placeholder="SN"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('device.device_code1')" prop="devcode">
                        <el-input v-model.trim="dialogForm.devcode" clearable :placeholder="$t('device.device_code1')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('device.device_address')" prop="devaddr">
                        <el-input v-model.trim="dialogForm.devaddr" clearable :placeholder="$t('device.device_address')"></el-input>
                    </el-form-item>


                    <el-form-item :label="$t('actionLog.startTime')" prop="sdate"
                        v-if="action == 'adminRebuildDisDeviceRealTimeDat' || action == 'adminDeleteEssDeviceRealtimeData'">
                        <el-date-picker v-model="dialogForm.sdate" ref="deviceFunctionHideS" type="date" :editable="false" 
                            value-format="yyyy-MM-dd" popper-class="select-date" :picker-options="pickerrangeOptions" :placeholder="$t('actionLog.startTime')"></el-date-picker>
                    </el-form-item>
                    <el-form-item :label="$t('actionLog.endTime')" prop="edate"
                        v-if="action == 'adminRebuildDisDeviceRealTimeDat' || action == 'adminDeleteEssDeviceRealtimeData'">
                        <el-date-picker v-model="dialogForm.edate" ref="deviceFunctionHideE" type="date" :editable="false" :picker-options="pickerrangeOptions"  popper-class="select-date" :placeholder="$t('actionLog.endTime')"
                            value-format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>

                    <el-form-item :label="$t('actionLog.startTime')" prop="sdate"
                        v-if="action == 'adminWebDeleteDeviceDat' && confirmFlag">
                        <el-input v-model="dialogForm.sdate" :placeholder="$t('actionLog.startTime')+' yyyy-mm-dd hh:mm:ss'"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('actionLog.endTime')" prop="edate"
                        v-if="action == 'adminWebDeleteDeviceDat' && confirmFlag">
                        <el-input v-model="dialogForm.edate" :placeholder="$t('actionLog.endTime')+' yyyy-mm-dd hh:mm:ss'"></el-input>
                    </el-form-item>

                    <!-- 二次确认 -->
                    <el-form-item :label="$t('device.SN')" prop="snConfirm"
                        v-if="action == 'adminUpdateFirstDataTime' || action == 'adminUpdateFirstDataTime' || (action == 'adminDeleteEssDeviceRealtimeData' && confirmFlag) || (action == 'adminWebDeleteDeviceDat' && confirmFlag)">
                        <el-input v-model.trim="dialogForm.snConfirm" clearable :placeholder="$t('device.SN_again')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('device.device_address')" prop="devaddrConfirm"
                        v-if="action == 'adminUpdateFirstDataTime ' || action == 'adminUpdateFirstDataTime' || (action == 'adminDeleteEssDeviceRealtimeData' && confirmFlag) || (action == 'adminWebDeleteDeviceDat' && confirmFlag)">
                        <el-input v-model.trim="dialogForm.devaddrConfirm" clearable :placeholder="$t('device.devaddr_again')"></el-input>
                    </el-form-item>

                    <!-- Grid占位 -->
                    <div></div>
                    <div style="text-align:right;">
                        <!-- 设备重滚确认 -->
                        <button type="button" class="btn btn-dark" @click="rebuildSubmit"
                            v-if="action == 'adminRebuildDeviceRealTimeDat'">{{ $t('basic.changeBtn')}}</button>
                        <!-- 设备同步确认 -->
                        <button type="button" class="btn btn-dark" @click="rebuildSubmit"
                            v-if="action == 'adminRebuildDisDeviceRealTimeDat'">{{ $t('account.confirm')
                            }}</button>
                        <!-- 修改设备第一笔时间  一次确认-->
                        <button type="button" class="btn btn-dark" @click="updateFirst" v-if="action == null">{{
                            $t('account.confirm')
                            }}</button>
                        <!-- 修改设备第一笔时间  二次确认-->
                        <button type="button" class="btn btn-dark" @click="updateFirstConfirm"
                            v-if="action == 'adminUpdateFirstDataTime'">{{
                                $t('account.confirm')
                            }}</button>
                        <!-- 删除设备图表数据 一次确认 -->
                        <button type="button" class="btn btn-dark" @click="deleteDevice"
                            v-if="action == 'adminDeleteEssDeviceRealtimeData' && !confirmFlag">{{
                                $t('account.confirm')
                            }}</button>

                        <!-- 删除设备图表数据 二次确认 -->
                        <button type="button" class="btn btn-dark" @click="updateFirstConfirm"
                            v-if="action == 'adminDeleteEssDeviceRealtimeData' && confirmFlag">{{
                                $t('account.confirm')
                            }}</button>
                           <!-- 删除设备数据明细 查询-->
                        <button type="button" class="btn btn-dark" @click="checkTimeZone"
                            v-if="action == 'adminWebDeleteDeviceDat' && !confirmFlag">{{$t('device.search_btn')}}</button>
                            <!-- 删除设备数据明细 确认-->
                        <button type="button" class="btn btn-dark" @click="updateFirstConfirm"
                            v-if="action == 'adminWebDeleteDeviceDat' && confirmFlag">{{ $t('account.confirm') }}</button>
                    </div>

                    <div class="tips" v-if="action == 'adminRebuildDisDeviceRealTimeDat'">
                        {{ $t('device.tips1') }}</div>
                    <div class="tips"
                        v-if="action == 'adminUpdateFirstDataTime' || (action == 'adminDeleteEssDeviceRealtimeData' && confirmFlag)">
                        {{ $t('device.tips2') }}</div>
                    <div class="tips" v-if="action == 'adminWebDeleteDeviceDat' && !confirmFlag">
                        {{ $t('device.tips3') }}</div>
                    <div class="tips" v-if="action == 'adminWebDeleteDeviceDat' && confirmFlag">
                        {{ $t('device.tips4_1') }} " {{ timeZone }} "， {{ $t('device.tips4_2') }}</div>

                </el-form>
            </account-dialog>
            <!-- 删除 -->
            <account-dialog :title="$t('alarm.deletes')" :visible.sync="showDeleteDialog" :width="'450px'"
            :class="{ 'showDialog': showDeleteDialog, 'hideDialog': !showDeleteDialog }" noFooter>
            <div class="content_tishi" slot="content">
                <div class="tital">
                    <!-- ${this.$t("factory.confirmDelete")}"${row.usr}"${this.$t("factory.confirmDelete1")} -->
                    <span class="contentdelete" style="width:100%;text-align:left;">
                       {{$t('device.delete_tips_1')}}{{ deleteRow[0] }}{{$t('device.delete_tips_2')}}?
                    </span>
                </div>
                <div class="deletfotter" style="text-align:right;margin-top:28px;">
                    <button type="button" class="btn btn-dark" style="margin-right:10px;" @click="confirmDelete">{{
                        $t('account.confirm') }}</button>
                    <button type="button" class="btn btn-light" @click="showDeleteDialog = false;">{{
                        $t('account.cancel')
                        }}</button>
                </div>
            </div>
        </account-dialog>
        </div>
    </div>
</template>
<script>
import accountDialog from "@/components/dialognew";
import { i18n } from "@/i18n";
import { mapState } from "vuex";
export default {
    components: {
        accountDialog
    },
      computed: {
            ...mapState({
      method: state => state.user.method,
      isMicroService: state => state.user.isMicroService,
      code: state => state.user.code,
      resData: state => state.user.resData
    })
  },
    data() {
        return {
            //弹框表单
            dialogForm: {
                pn: '',
                sn: '',
                devcode: '',
                devaddr: '',
                sdate: '',
                edate: '',
                snConfirm: '',
                devaddrConfirm: ''
            },
            //二次删除flag
            confirmFlag: false,
            //时区
            timeZone: '',
            // 弹框表单验证规则
            dialogRules: {
                pn: [{ required: true, trigger: "change" ,message:i18n.t('message.pn_is_required')}],
                sn: [{ required: true, trigger: "change",message:i18n.t('device.sn_is_required') }],
                devcode: [{ required: true, trigger: "change",message:i18n.t('factory.devcode_is_requeired') }],
                devaddr: [{ required: true, trigger: "change" ,message:i18n.t('datalogger.devaddrfail') }],
                snConfirm: [{ required: true, trigger: "change" ,message:i18n.t('device.SN_again')}],
                devaddrConfirm: [{ required: true, trigger: "change",message:i18n.t('device.devaddr_again') }],
                edate: [{ required: true, trigger: "change",message:i18n.t('device.edate_required') }],
                sdate: [{ required: true, trigger: "change",message:i18n.t('device.sdate_required') }],

            },
            //分页
            pagination: {
                page: 1,
                pagesize: 50,
                total: 0
            },
            loadingDatalogger: false,
            //表格数据
            dataList: [],
            //表头
            rowTitle: [],
            //弹框
            showDialog: false,
            //弹框标题
            dialogTitle: '',
            //接口
            action: '',
            //删除弹框
            showDeleteDialog: false,
            //搜索表单验证
            searchFormRules: {
                pn: [{ required: true, trigger: "change" }],
                sn: [{ required: true, trigger: "change" }],
                devcode: [{ required: true, trigger: "change" }],
                devaddr: [{ required: true, trigger: "change"}],
                date: [{ required: true, trigger: "change" }],
            },

            //搜索表单
            searchForm: {
                pn: '',
                sn: '',
                devcode: '',
                devaddr: '',
                date: new Date(),
            },
            //删除行
            deleteRow:[],
            pickerrangeOptions: {
              disabledDate: time => {
                return (
                  time.getTime() >
                  new Date(
                    new Date(new Date().toLocaleDateString()).getTime() +
                      24 * 60 * 60 * 1000 -
                      1
                  )
                );
              }
            }
        };
    },
    watch: {
     showDialog (val) {
      if (!val) {
        if(this.$refs.deviceFunctionHideS)
        this.$refs.deviceFunctionHideS.handleClose()
        if(this.$refs.deviceFunctionHideE)
        this.$refs.deviceFunctionHideE.handleClose()
        document.removeEventListener('click', this.handleDocumentClick, true);
      }else{
        document.addEventListener('click', this.handleDocumentClick, true);
      }
     },
    },
    methods: {
        handleDocumentClick(event) {
          if (this.$refs.deviceFunctionHideS&&!this.$refs.deviceFunctionHideS.$el.contains(event.target)&&event.target.closest('.select-date') == null) {
            // 手动关闭日期选择器和对话框
            this.$refs.deviceFunctionHideS.handleClose()
          }
          if(this.$refs.deviceFunctionHideE&&!this.$refs.deviceFunctionHideE.$el.contains(event.target)&&event.target.closest('.select-date') == null){
            this.$refs.deviceFunctionHideE.handleClose()
          }
        },
        //打开弹框显示对应内容
        openDiaolog(action) {
            this.$refs.creatForm.resetFields();
            this.dialogForm = {
                pn: '',
                sn: '',
                devcode: '',
                devaddr: '',
                sdate: '',
                edate: '',
                snConfirm: '',
                devaddrConfirm: ''
            };
            this.confirmFlag = false;
            this.showDialog = true;
            this.action = action;
            if (action == 'adminRebuildDeviceRealTimeDat') {
                this.dialogTitle = i18n.t('device.device_rerolling');
            } else if (action == 'adminRebuildDisDeviceRealTimeDat') {
                this.dialogTitle = i18n.t('device.device_synchronization');
            } else if (action == null) {
                this.dialogTitle = i18n.t('device.update_first_data_time');
            } else if (action == 'adminDeleteEssDeviceRealtimeData') {
                this.dialogTitle = i18n.t('device.delete_device_chart_data');
            } else if (action == 'adminWebDeleteDeviceDat') {
                this.dialogTitle = i18n.t('device.delete_device_data');
            }
        },
        // 列表数据
        getData() {
            this.$refs.searchForm.validate(valid => {
                if (!valid) {
                    this.$message.error(i18n.t('device.data_tips'))
                    return false;
                }
                let ps = this.isMicroService ? 'pageSize': 'pagesize'
                let params = {
                    ...this.searchForm,
                    [ps]: this.pagination.pagesize,
                    page:this.isMicroService? this.pagination.page : this.pagination.page - 1 ,
                    i18n: this.$lang.currentLang
                };
                    let url = this.isMicroService ? "/drt/api/auth/web/deviceDats" : "queryDeviceDataOneDayPaging";
      this.$request[this.method](url, params)
                    .then(res => {
                        this.loadingDatalogger = false;
                       if (res[this.code] === 0) {
                            this.rowTitle = res[this.resData].title;
                            this.rowTitle.shift()
                            this.dataList = res[this.resData].row.map(item => {
                                item.field.shift()
                                return item
                            })
                            this.pagination.total = res[this.resData].total
                        } else {
                            this.$message.error(this.$t(`errCode.${res[this.code]}`));
                            this.dataList = [];
                            this.rowTitle = []
                        }
                    })
                    .catch(err => {
                        this.dataList = [];
                        this.rowTitle = []
                    });

            });


        },

        // 设备重滚/设备同步 提交
        rebuildSubmit() {
            this.$refs.creatForm.validate(valid => {
                if (!valid) {
                    this.$message.error(i18n.t('device.data_tips'))
                    return false;
                }
                let params = {
                    ...this.dialogForm,
                    i18n: this.$lang.currentLang
                };
                this.$request.get(this.action, params).then(res => {
                    if (res.err == 0) {
                        this.showDialog = false;
                        // this.getData();
                        this.$message.success(i18n.t('project.modifySuc'));
                    } else {
                        this.$message.error(this.$t(`errCode.${res.err}`));
                    }
                });

            });
        },
        // 修改设备第一笔时间 一次确认
        updateFirst() {
            this.$refs.creatForm.validate(valid => {
                if (!valid) {
                    this.$message.error(i18n.t('device.data_tips'))
                    return false;
                }
                this.action = 'adminUpdateFirstDataTime'
            })
        },
        deleteDevice() {
            this.$refs.creatForm.validate(valid => {
                if (!valid) {
                    this.$message.error(i18n.t('device.data_tips'))
                    return false;
                }
                this.confirmFlag = true
            })
        },
        // 修改设备第一笔时间/删除设备图表数据 二次确认
        updateFirstConfirm() {
            this.$refs.creatForm.validate(valid => {
                if (!valid) {
                    this.$message.error(i18n.t('device.data_tips'))
                    return false;
                }
                if (this.dialogForm.sn != this.dialogForm.snConfirm || this.dialogForm.devaddr != this.dialogForm.devaddrConfirm) {
                    this.$message.error(i18n.t('device.match_tips'))
                    return false;
                }
                let params = {
                    ...this.dialogForm,
                    syyyymmdd:this.dialogForm.sdate.split('-').join(''),
                    eyyyymmdd:this.dialogForm.edate.split('-').join(''),
                    i18n: this.$lang.currentLang,
                    lang: this.$lang.currentLang
                };
                this.$request.get(this.action, params).then(res => {
                    if (res.err == 0) {
                        this.showDialog = false;
                        this.$message.success(i18n.t('project.modifySuc'));
                    } else {
                        this.$message.error(this.$t(`errCode.${res.err}`));
                    }
                });

            });
        },
        // 查询时区
        checkTimeZone() {
            this.$refs.creatForm.validate(valid => {
                if (!valid) {
                    this.$message.error(i18n.t('device.data_tips'))
                    return false;
                }
                let params = {
                    ...this.dialogForm,
                    i18n: this.$lang.currentLang
                };
                this.$request.get('adminQueryDeviceAndPlantToTimeZone', params).then(res => {
                    if (res.err == 0) {
                        this.timeZone = res.dat;
                        this.confirmFlag = true
                    } else {
                        this.$message.error(this.$t(`errCode.${res.err}`));
                    }
                });

            });
        },

        // 删除编码按钮
        cellDelete(row) {
            this.deleteRow = row.field;
            this.showDeleteDialog = true;
        },
        // 删除数采器编码确认按钮
        confirmDelete() {
            let params = {
                ...this.searchForm,
                sdate:this.deleteRow[0],
                edate:this.deleteRow[0],
                i18n: this.$lang.currentLang
            };
            this.$request.get("adminWebDeleteDeviceDat", params).then(res => {

                if (res.err == 0) {
                    this.getData();
                    this.$message.success(i18n.t('project.modifySuc'));
                    this.showDeleteDialog = false;
                } else {
                    this.$message.error(this.$t(`errCode.${res.err}`));
                }
            });
        },

    }
};
</script>
<style lang="less" scoped>
@import url("../../../../assets/css/mixin.less");

.dataloggerManage {
    display: flex;
    flex: 1;
    flex-direction: column;
    margin: 20px;
    // background-color: rgb(34, 45, 53);
    overflow: auto;

    .chuangjian,
    .bianji,
    .chongzhi {
        .juxing {
            display: inline-block;
            width: 100px;
            height: 10px;
            border: 0px solid #fff;
            margin-left: 5px;
        }

        .inputlo {
            margin-bottom: -16px;
            height: 20px;
        }

        .input_spans,
        .pwd_span,
        .email_span,
        .phone_span,
        .confpwd_span {
            height: 20px;
            line-height: 20px;
            color: #f56c6c;
            font-size: 12px;
        }

        .input_span {
            height: 20px;
            line-height: 20px;
        }

        .sucess {
            height: 20px;
            line-height: 20px;
            font-size: 12px;
            color: #999;
            // font-family: "Microsoft YaHei";
        }

        /deep/ .el-form-item__error {
            padding-top:0;
        }
    }

    .btn {
        padding: 6px 12px;
        border-radius: 6px;
        font-size: 14px;
        cursor: pointer;
    }

    .btn-disable {
        color: rgba(242, 242, 242, 0.5);
        background: rgba(43, 56, 66, 1);
        cursor: not-allowed;
    }

    .btn-dark {
        background: @primaryTextColor;
        color: rgba(34, 45, 53, 1);
        border: none;
    }

    .btn-light {
        background: transparent;
        color: @primaryTextColor;
        border: 1px solid @primaryTextColor;
    }

    .ico-recharge {
        background: url(../../../../assets/img/general/Icon_Recharge.png);
    }

    .ico {
        display: inline-block;
        width: 20px;
        height: 20px;
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
        vertical-align: middle;
    }

    .section {
        display: flex;
        flex: 1;
        padding: 0px;
        flex-direction: column;
        border-radius: 0px;
        border: none;
        background: rgb(34, 45, 53);
        position: relative;
        overflow: hidden;

        /deep/.el-icon-loading {
            font-size: 28px;
        }

        .buttons {
            border-bottom: 1px solid #EBEEF5;
            padding: 5px 10px;
            .buttonType {
                height: 48px;
                line-height: 48px;
                padding: 0 17px 0 12px;
                border-radius: 0;
            }
        }

        .search {
            margin: 0px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: rgb(34, 45, 53);
            border-bottom: 1px solid #EBEEF5;

            .searchLeft {
                .buttonDeviceJurisdiction {
                    padding: 0 17px 0 12px;
                    background-color: @primaryTextColor;
                    color: #222d35;
                    border-radius: 0;

                    span {
                        padding-left: 5px;
                    }
                }
            }

            .searchRight {
                display: flex;
                align-items: center;
                justify-content: flex-start;

                .tool {
                    /deep/.el-date-editor.el-input .el-input__prefix {
                        right: auto;
                        left: 16px;
                        font-size: 16px;
                        color: #00febb;
                    }

                    /deep/.el-date-editor.el-input .el-input__inner {
                        height: 46px;
                        padding-left: 52px;
                        background: transparent;
                        color: #ffffff;
                        border: none;
                        border-radius: 0px;
                        // border-left: 1px solid #7B8395;
                        // border-right: 1px solid #7B8395;
                    }

                    /deep/.el-date-editor.el-input .el-input__suffix .el-input__icon:after {
                        content: "";
                        display: inline-block;
                        position: absolute;
                        top: 12px;
                        right: -2px;
                        height: 20px;
                        width: 20px;
                        background: url(../../../../assets/img/general/Icon_Down_Border.png) no-repeat;
                        background-size: 100%;
                        background-position: center;
                    }

                    // 时间图标
                    /deep/.el-icon-date:before {
                        content: "";
                        display: inline-block;
                        position: absolute;
                        top: 12px;
                        left: 0px;
                        height: 24px;
                        width: 24px;
                        background: url(../../../../assets/img/general/Icon_Calendar.png) no-repeat;
                        background-size: 100%;
                        background-position: center;
                    }

                    .datePreNext {
                        padding: 0px 16px;
                        border-right: 1px solid #7b8395;
                        border-left: 1px solid #7b8395;

                        /deep/.datepicker {
                            margin: 0px;
                            // margin-right: 16px;
                        }

                        /deep/.el-date-editor {
                            margin-right: 16px;
                        }

                        /deep/.el-date-editor.el-input {
                            width: 150px;
                        }

                        /deep/.el-date-editor.el-input .el-input__inner {
                            padding: 0px;
                            text-align: center;
                        }

                        //.el-input__prefix,
                        //.el-input__suffix
                        /deep/.el-input__prefix {
                            display: none;
                        }

                        /deep/.el-input__suffix {
                            top: 2px;
                            right: 16px;
                        }

                        .date-icon {
                            display: inline-block;
                            width: 24px;
                            height: 24px;
                            background: url(../../../../assets/img/general/Icon_Calendar.png);
                            background-size: 100%;
                            background-position: center;
                            background-repeat: no-repeat;
                            vertical-align: middle;
                            margin-right: 16px;
                        }

                        .date-pre {
                            background: url(../../../../assets/img/general/Chart_Date_Pre.png);
                        }

                        .date-next {
                            background: url(../../../../assets/img/general/Chart_Date_Next.png);
                        }

                        .date-btn {
                            color: #ffffff;
                            cursor: pointer;
                            display: inline-block;
                            height: 16px;
                            width: 16px;
                            background-size: 100%;
                            background-position: center;
                            background-repeat: no-repeat;
                            vertical-align: middle;
                        }
                    }
                }

                .searchAll {
                    /deep/.el-input__inner {
                        width: 220px;
                        padding-left: 10px;
                    }
                }

                .search-device {
                    display: inline-block;
                    line-height: 48px;
                    padding: 0 15px;
                    width: 100%;
                    font-size: 14px;
                    background: #202d35;
                    color: #33ffb6;
                    cursor: pointer;
                    // border-right: 1px solid #7b8395;

                    &:hover {
                        background: @primaryColorTransparency30;
                        color: rgb(255, 255, 255, 1);
                    }
                }

                .search-hide {
                    display: inline-block;
                    // position: absolute;
                    // right: -58px;
                    // line-height: 48px;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 0 15px;
                    font-size: 14px;
                    background: #202d35;
                    color: #7b8395;
                    border-left: 1px solid #7b8395;
                    cursor: pointer;

                    &:hover {
                        background: @primaryColorTransparency30;
                        color: rgb(255, 255, 255, 1);
                    }
                }
            }

            .active {
                color: #00febb;
                border-bottom: 2px solid #00febb;
            }

            /deep/.el-select {
                width: 100px;
                border-right: 1px solid #738089;
            }

            /deep/.el-select:hover {
                background: @primaryColorTransparency30;
            }

            /deep/.el-input {
                width: 100%;
                text-align: center;
            }

            /deep/.el-input__inner {
                background: transparent;
                border: none;
                height: 48px;
                line-height: 48px;
                color: #ffffff;
                padding: 0 16px;
            }

            /deep/.el-input__suffix {
                right: 0px;
            }

            .button {
                height: 48px;
                line-height: 48px;
                padding: 0 25px;
                margin-top: 0px;
                color: @primaryTextColor;
                background: transparent;
                border: none;
            }

            .batch-alert {
                height: 48px;
                line-height: 48px;
            }
        }

        .tableloding {

            // 加载数据时遮罩
            /deep/.el-loading-mask {
                background-color: rgb(34, 45, 53, 0.5);
            }

            /deep/.el-loading-spinner i {
                color: @primaryTextColor;
            }
        }

        .tablemain {
            border: none;
            background-color: rgb(34, 45, 53);

            .operation i {
                color: @primaryTextColor;
            }

            .operation1 i {
                color: @primaryColorTransparency30;
            }

            // 表格右侧边线
            // /deep/.el-table--border::after,
            // /deep/.el-table--group::after {
            //   width: 0px;
            // }
            /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
                width: 16px;
                height: 16px;
                background: transparent;
                border: 1px solid rgb(180, 184, 193);
                border-radius: 0px;
            }

            /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
                top: 2px;
                left: 5px;
            }

            /deep/.el-table__header th {
                height: 48px;
            }

            /deep/.el-table__header th.is-leaf {
                border-color: rgba(198, 209, 221, 0.5);
                // border-bottom: none;
            }

            /deep/.el-table__header th>.cell {
                font-weight: normal;
                font-size: 12px;
            }

            /deep/.el-table__body tr,
            /deep/.el-table__body td {
                background-color: rgb(34, 45, 53);
                color: #ffffff;
                border-color: rgba(198, 209, 221, 0.5);
            }

            /deep/.el-table__body td.el-table-column--selection {
                background-color: rgb(65, 80, 90);
                color: #ffffff;
            }

            /deep/.el-table__body .cell.el-tooltip {
                font-size: 14px;
            }

            /deep/.el-table__fixed-right::before,
            /deep/.el-table__fixed::before {
                display: none;
            }

            // ::-webkit-scrollbar {
            //     width: 6px;
            //     height: 6px;
            //     background-color: #222d35;
            // }

            // 关于复选框
            /deep/.el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
                background: @primaryTextColor;
                border: 1px solid @primaryTextColor;
            }

            /deep/.el-checkbox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
                background: @primaryTextColor;
                border: 1px solid @primaryTextColor;
            }

            // 关于头部右侧空白
            /deep/.el-table__fixed-right-patch {
                background-color: rgb(65, 80, 90);
                border-bottom: none;
            }

            /deep/th.gutter {
                background-color: rgb(65, 80, 90);
            }
        }

        .tablebottom {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-top: 1px solid rgba(198, 209, 221, 0.5);

            // 分页
            .pagination {
                line-height: 48px;
                height: 48px;
                padding: 0;
                margin: 0;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                margin-right: 16px;

                /deep/.el-pager li {
                    vertical-align: middle;
                }

                /deep/.el-select .el-input {
                    width: 90px;
                    margin: 0px;
                }

                /deep/.el-input .el-input__inner {
                    background-color: #202d35;
                    color: #ffffff;
                }

                /deep/.el-input__suffix {
                    right: 10px;
                }

                /deep/.el-pagination__sizes {
                    margin: 0px;
                    height: 48px;
                    line-height: 48px;
                }

                /deep/.el-pagination__total {
                    color: #fff;
                    padding-left: 15px;
                    border-left: 1px solid #7b8395;
                    height: 48px;
                    line-height: 48px;
                }

                /deep/.el-pager li:not(.disabled).active {
                    // background: #15C491;
                    // color: #ffffff;
                    background-color: #2b3842;
                    color: #15c491;
                }

                // li:not(.disabled):not(.active):hover
                /deep/.el-pager li:not(.disabled):hover {
                    background-color: @primaryColorTransparency30;
                    color: rgba(255, 255, 255, 1);
                }

                /deep/.el-pager li {
                    background-color: #2b3842;
                    color: #7b8395;
                }

                // 页条数下拉
                /deep/.el-select .el-input .el-input__inner {
                    border: none;
                    height: 48px;
                    line-height: 48px;
                    border-radius: 0px;
                }

                /deep/.el-select .el-input .el-input__inner:hover {
                    background: @primaryColorTransparency30;
                }

                // 跳页
                /deep/.el-pagination__jump {
                    color: #ffffff;
                }

                /deep/.el-pagination__editor {
                    padding: 0px 6px;
                }

                /deep/.el-pagination__editor.el-input .el-input__inner {
                    border: 1px solid #7b8395;
                }
            }

            // 分页前后按钮
            /deep/.el-pagination.is-background .btn-next,
            /deep/.el-pagination.is-background .btn-prev {
                background-color: #2b3842;
                color: #7b8395;
            }

            /deep/.el-pagination.is-background .btn-next:hover,
            /deep/.el-pagination.is-background .btn-prev:hover {
                background-color: @primaryColorTransparency30;
                color: rgba(255, 255, 255, 1);
            }

            /deep/.el-pagination.is-background button[disabled],
            /deep/.el-pagination.is-background button[disabled]:hover {
                background-color: #2b3842;
                color: #7b8395;
            }
        }
    }

    // ::-webkit-scrollbar {
    //     width: 0px;
    //     height: 0px;
    //     background-color: #222d35;
    // }

    .searchForm {
        display: flex;
        width: 100%;

        .el-form-item {
            display: flex;
            align-items: center;
            margin-bottom: 0;
            color: white;
            padding: 0 10px;

            /deep/.el-form-item__label {
                color: white;


            }

            /deep/.el-input {
                border-right: 1px solid #738089;
            }
        }

    }

    .tips {
        bottom: 10px;
        position: absolute;
        width: 400px;
        color: rgb(235, 59, 59);
    }

    .dataTable {
        width: 100%;
        overflow-x: auto;
        color: white;

        table {
            border-color: rgba(198, 209, 221, 0.5);
            border-right: none;
            border-left: none;
            border-collapse: collapse;
            text-align: center;
            position: relative;

            tbody {
                display: block;
                width: 100%;
                overflow-x: scroll;
            }

            th,
            td {
                font-weight: normal;
                white-space: nowrap;
                border-collapse: collapse;
                font-size: 14px;
                padding: 0 10px;
                // border: 1px solid #eee;
            }

            th {
                background: rgb(65, 80, 90);
                font-size: 12px;
                padding: 20px 10px;
            }

            th:first-child,
            td:first-child {
                border-left: none;
                background: rgb(65, 80, 90);
                position: sticky;
                left: 0;
                z-index: 1;
            }

            td:first-child {
                background: #222d35;
            }

            th:last-child,
            td:last-child {
                border-right: none;
                background: rgb(65, 80, 90);
                position: sticky;
                right: 0;
                z-index: 1;
            }

            td:last-child {
                background: #222d35;
            }
        }

        // table thead,tbody tr {
        //         display: table;
        //         width:100%;
        //         table-layout: fixed;
        //     }
    }
}
</style>
<style lang="less">
// #下拉选框#
.select-search-recharge {
    background-color: rgb(34, 45, 53);
    box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
    border-radius: 4px;
    border: none;
    padding: 8px 0px;

    .el-select-dropdown__list {
        padding: 0px;
    }

    .el-select-dropdown__item {
        padding: 0px 16px;
        font-size: 14px;
        height: 32px;
        line-height: 32px;
        color: rgba(255, 255, 255, 1);
    }

    .el-select-dropdown__item.hover {
        display: flex;
        align-items: center;
        padding: 0px 16px;
        background-color: transparent;
        font-weight: normal;
    }

    .el-select-dropdown__item.selected {
        padding: 0px 16px;
        background-color: transparent;
        font-weight: normal;
        color: rgba(255, 255, 255, 1);
    }

    .el-select-dropdown__item:hover {
        padding: 0px 16px;
        background: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
    }

    .el-select-dropdown__item.selected .select-label {
        padding: 0px;
    }

    // 对号
    .el-select-dropdown__item.selected:before,
    .el-select-dropdown__item.selected .select-label:before,
    .el-select-dropdown__item.selected.choose-num:before {
        content: "";
        display: inline-block;
        height: 16px;
        width: 16px;
        background: url(../../../../assets/img/general/Icon_Duihao.png);
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
        position: absolute;
        top: 8px;
        right: 16px;
    }

    // 下拉框上传固件按钮
    .upFirewareBtn {
        background: rgba(34, 45, 53, 1);
        border: 1px solid rgba(226, 227, 227, 1);
        border-radius: 6px;
        padding: 6px 30px;
        color: rgba(226, 227, 227, 1);
        font-size: 14px;
        cursor: pointer;
    }
}

.select-search-project {
    .el-select-dropdown__list {
        padding: 0 16px;
    }

    .el-select-dropdown__item {
        height: 40px;
        line-height: 40px;
        box-shadow: 0px 0.5px rgba(198, 209, 221, 0.2);
    }
}

.selectClearNew {

    // 下拉选中清除按钮
    .el-icon-circle-close:before {
        content: "";
        display: inline-block;
        height: 16px;
        width: 16px;
        background: url(../../../../assets/img/general/Icon_SelectClear.png);
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
        // position: absolute;
        // top: 8px;
        // right: 16px;
    }
}

// #时间选择器 el-date-picker#
.select-date {

    // 下拉
    &.el-date-picker {
        background: rgba(34, 45, 53, 1);
        border: none;
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.48);
    }

    // 切换日 -----
    // 头部切换
    .el-date-picker__header {
        padding: 0px 50px;
    }

    .el-date-picker__header-label {
        color: rgba(238, 236, 241, 1);
    }

    // 前后切换
    .el-picker-panel__icon-btn {
        color: rgba(48, 208, 150);
        font-size: 14px;
        font-weight: bold;
    }

    // 一周
    .el-date-table th {
        color: rgba(238, 236, 241, 1);
        border: none;
    }

    // 日
    .el-date-table td div {
        padding: 0px;
    }

    .el-date-table td.today span {
        color: #00febb;
        font-weight: normal;
    }

    .el-date-table td.available {
        color: rgba(122, 117, 133, 1);
        font-size: 14px;
    }

    .el-date-table td.available:hover {
        color: #00febb;
    }

    .el-date-table td.current:not(.disabled) span {
        width: 30px;
        height: 30px;
        line-height: 26px;
        text-align: center;
        border-radius: 16px;
        border: 2px solid @primaryColorTransparency30;
        background: @primaryColorTransparency30;
        color: rgba(51, 255, 182, 1);
        margin-top: -3px;
    }

    .el-date-table td.next-month,
    .el-date-table td.prev-month {
        color: rgb(60, 56, 68);
        font-size: 16px;
    }

    // 切换月 -----
    .el-date-picker__header--bordered {
        border: none;
    }

    // 月
    .el-month-table td.today .cell {
        color: #00febb;
    }

    .el-month-table td.current:not(.disabled) .cell {
        border-radius: 6px;
        border: 2px solid @primaryColorTransparency30;
        background: @primaryColorTransparency30;
        color: rgba(51, 255, 182, 1);
        line-height: 32px;
    }

    .el-month-table td .cell {
        color: #7b8395;
    }

    .el-month-table td .cell:hover {
        color: #00febb;
    }

    // 切换年 -----
    // 年
    .el-year-table td.today .cell {
        color: #00febb;
    }

    .el-year-table td.current:not(.disabled) .cell {
        border-radius: 6px;
        border: 2px solid @primaryColorTransparency30;
        background: @primaryColorTransparency30;
        color: rgba(51, 255, 182, 1);
        line-height: 28px;
    }

    .el-year-table td .cell {
        color: #7b8395;
    }

    .el-year-table td .cell:hover {
        color: #00febb;
    }
}

.tablemain.el-table--border::after {
    display: none;
}
</style>
<style lang="less">
// 日期选择器增加今日快捷
.select-date {
    width: 320px !important;
    padding-top: 10px;

    // 头部
    .el-date-picker__header {
        width: 100%;
        margin: 12px 0px !important;
        padding: 0px 30px !important;
    }

    .el-picker-panel__body-wrapper {
        display: flex;
        flex-direction: column-reverse;
        justify-content: flex-end;
        align-items: flex-end;

        .el-picker-panel__sidebar {
            width: 100%;
            position: relative;
            padding: 0px;
            background: transparent;
            color: #ffffff;
            border: none;

            .el-picker-panel__shortcut,
            .el-picker-panel__shortcut:hover {
                // margin-top: 0px;
                padding-left: 0px;
                padding-bottom: 20px;
                color: @primaryTextColor;
                text-align: center;
            }
        }
    }
}

.el-date-table td.disabled div {
    background-color: #222d35 !important;
    color: #606266 !important;
}

.el-year-table td.disabled .cell {
    background-color: #222d35 !important;
}

.el-month-table td.disabled .cell {
    background-color: #222d35 !important;
}

// 分页</style>